import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Cookie Policy | Nirmitee Associates</title>
        <meta name="description" content="Cookie Policy of Nirmitee Associates. Learn about how we use cookies on our website." />
      </Helmet>

      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-8 text-center">
              Cookie Policy
            </h1>
            
            <div className="prose prose-lg max-w-none text-muted-foreground">
              <p className="mb-6">
                This is the Cookie Policy for Nirmitee Associates, accessible from nirmitee.in.
              </p>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">1. What Are Cookies</h2>
                <p className="mb-4">
                  As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">2. How We Use Cookies</h2>
                <p className="mb-4">
                  We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">3. Disabling Cookies</h2>
                <p className="mb-4">
                  You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of this site.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">4. The Cookies We Set</h2>
                <ul className="list-disc pl-6 space-y-4">
                  <li>
                    <strong>Account related cookies:</strong> If you create an account with us then we will use cookies for the management of the signup process and general administration.
                  </li>
                  <li>
                    <strong>Login related cookies:</strong> We use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time you visit a new page.
                  </li>
                  <li>
                    <strong>Site preferences cookies:</strong> In order to provide you with a great experience on this site we provide the functionality to set your preferences for how this site runs when you use it.
                  </li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">5. Third Party Cookies</h2>
                <p className="mb-4">
                  In some special cases we also use cookies provided by trusted third parties. The following section details which third party cookies you might encounter through this site.
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>This site uses Google Analytics which is one of the most widespread and trusted analytics solution on the web for helping us to understand how you use the site and ways that we can improve your experience.</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-foreground mb-4">6. More Information</h2>
                <p className="mb-4">
                  Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site.
                </p>
                <p>
                  However if you are still looking for more information then you can contact us through one of our preferred contact methods:
                </p>
                <ul className="list-none mt-4 space-y-2">
                  <li>Email: nirmitee.associates2919@gmail.com</li>
                </ul>
              </section>

              <p className="text-sm italic mt-12">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CookiePolicy;
